<template>
  <el-main>
    <div class="sys-content" style="text-align: center">
      <h1>{{msg}}</h1>
    </div>
  </el-main>

</template>

<script>
import store from '../store/index'
import user from '@/api/user'
export default {
  name: 'Index',
  data () {
    return {
      // msg: '在线统计：可查看当前直播用户在线情况(列表显示、显示总人数)或正在回看直播和观看优质视频的用户在线情况。' +
      //   '在线曲线：曲线图形式显示直播用户在线情况或正在回看直播和观看优质视频的用户在线情况'
      msg: '欢迎来到河南律师之家后台',
      userId: null
    }
  },
  methods: {
    reload () {
      if (store.getters.getUserId) {
        this.userId = store.getters.getUserId
      }
      // 查询管理员所属协会
      user.findById({id: this.userId}).then(res => {
      })
    }
  },
  created () {
    this.reload()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue